
import React, { useState } from 'react';
import { Container, Row, Col, Card, Table, Form, Button, Dropdown, Badge } from 'react-bootstrap';
import { TbCalendar, TbEdit, TbTrash, TbSearch } from 'react-icons/tb';

import PipelineHeader from '../../../components/crm/pipeline/PipelineHeader'
import EditPipelineModal from '../../../components/modals/crm/pipeline/edit-pipeline/EditPipelineModal';
import DeleteConfirmModal from '../../../components/modals/crm/pipeline/DeleteConfirmModal';
const initialData = [
  { id: 1, name: "Sales", value: "$4,50,000", deals: 315, stage: "Won", color: "success", date: "14 Jan 2024", status: "Active" },
  { id: 2, name: "Marketing", value: "$3,15,000", deals: 447, stage: "In Pipeline", color: "purple", date: "21 Jan 2024", status: "Active" },
  { id: 3, name: "Calls", value: "$8,40,000", deals: 654, stage: "Won", color: "success", date: "20 Feb 2024", status: "Active" },
  { id: 4, name: "Email", value: "$6,10,000", deals: 545, stage: "Conversation", color: "info", date: "15 Mar 2024", status: "Active" },
  { id: 5, name: "Chats", value: "$4,70,000", deals: 787, stage: "Won", color: "info", date: "12 Apr 2024", status: "Active" },
  { id: 6, name: "Operational", value: "$5,50,000", deals: 787, stage: "Follow Up", color: "warning", date: "20 Apr 2024", status: "Active" },
  { id: 7, name: "Collaborative", value: "$5,00,000", deals: 315, stage: "Won", color: "success", date: "06 Jul 2024", status: "Inactive" },
  { id: 8, name: "Differentiate", value: "$4,50,000", deals: 478, stage: "Schedule service", color: "pink", date: "02 Sep 2024", status: "Active" },
  { id: 9, name: "Interact", value: "$6,20,000", deals: 664, stage: "Won", color: "success", date: "15 Nov 2024", status: "Active" },
];

const PipelinePage = () => {
  const [data, setData] = useState(initialData);
  const [searchTerm, setSearchTerm] = useState('');
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedPipeline, setSelectedPipeline] = useState(null);
// calendar
const [selectedRange, setSelectedRange] = useState("Last 7 Days");
  const [dateText, setDateText] = useState("04/11/2026 - 04/17/2026");
  // Filter data
  const filteredData = data.filter(item =>
    item.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleEdit = (pipeline) => {
    setSelectedPipeline(pipeline);
    setShowEditModal(true);
  };

  const handleDelete = (pipeline) => {
    setSelectedPipeline(pipeline);
    setShowDeleteModal(true);
  };

  const confirmDelete = () => {
    setData(data.filter(item => item.id !== selectedPipeline.id));
    setShowDeleteModal(false);
  };

  const getStageColor = (color) => {
    const colors = {
      success: '#22C55E',
      purple: '#8B5CF6',
      info: '#3B82F6',
      warning: '#EAB308',
      pink: '#EC4899',
    };
    return colors[color] || '#6B7280';
  };


  const presets = [
    { label: "Today", value: "Today" },
    { label: "Yesterday", value: "Yesterday" },
    { label: "Last 7 Days", value: "Last 7 Days" },
    { label: "Last 30 Days", value: "Last 30 Days" },
    { label: "This Year", value: "This Year" },
    { label: "Next Year", value: "Next Year" },
    { label: "Custom Range", value: "Custom Range" },
  ];

  const updateDateRange = (label) => {
    setSelectedRange(label);
    
    const today = new Date();
    let startDate = new Date();
    let endDate = new Date();

    switch (label) {
      case "Today":
        startDate = endDate = today;
        break;
      case "Yesterday":
        startDate = endDate = new Date(today.setDate(today.getDate() - 1));
        break;
      case "Last 7 Days":
        startDate = new Date(today.setDate(today.getDate() - 7));
        endDate = new Date();
        break;
      case "Last 30 Days":
        startDate = new Date(today.setDate(today.getDate() - 30));
        endDate = new Date();
        break;
      case "This Year":
        startDate = new Date(today.getFullYear(), 0, 1);
        endDate = new Date();
        break;
      case "Next Year":
        startDate = new Date(today.getFullYear() + 1, 0, 1);
        endDate = new Date(today.getFullYear() + 1, 11, 31);
        break;
      case "Custom Range":
        setDateText("Select Custom Range");
        return;
      default:
        return;
    }

    const formatDate = (date) => {
      return date.toLocaleDateString('en-US', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric'
      });
    };

    setDateText(`${formatDate(startDate)} - ${formatDate(endDate)}`);
  };

  return (

       <div   style={{ padding: "17px", background: "#f8f9fa",  }} >
      <PipelineHeader/>

      <Card className="shadow-sm border-0">
        {/* Header with Filters */}
        <Card.Header className="bg-white border-0 py-4">
          <Row className="align-items-center g-3">
            <Col md={4}>
              <h4 className="mb-0 fw-semibold">Pipeline List</h4>
            </Col>
            <Col md={8}>
              <div className="d-flex flex-wrap gap-2 justify-content-md-end">
                {/* Date Range */}
        <Dropdown>
      <Dropdown.Toggle 
        variant="white" 
        className="border w-100 text-start d-flex align-items-center shadow-none"
        style={{ 
          height: '40px', 
          padding: '7px 7px',
          borderRadius: '8px',
          fontSize: '15px',
          color: '#111827'
        }}
      >
        <TbCalendar size={20} className="me-2 text-muted" />
        <span>{dateText}</span>
      </Dropdown.Toggle>

      <Dropdown.Menu 
        className="shadow border-0 py-2" 
        style={{ minWidth: '220px' }}
      >
        {presets.map((item) => (
          <Dropdown.Item
            key={item.value}
            onClick={() => updateDateRange(item.label)}
            className={`py-2 px-3 ${selectedRange === item.label ? 'bg-orange text-white' : ''}`}
            style={{
              backgroundColor: selectedRange === item.label ? '#FF6B00' : 'transparent',
              color: selectedRange === item.label ? 'white' : '#374151',
              fontWeight: selectedRange === item.label ? '500' : 'normal'
            }}
          >
            {item.label}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>

                <Dropdown>
                  <Dropdown.Toggle variant="white" className="border">Stage</Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item>Won</Dropdown.Item>
                    <Dropdown.Item>In Pipeline</Dropdown.Item>
                    <Dropdown.Item>Conversation</Dropdown.Item>
                    <Dropdown.Item>Follow Up</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>

                <Dropdown>
                  <Dropdown.Toggle variant="white" className="border">$0.00 - $0.00</Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item>$10 - $20</Dropdown.Item>
                    <Dropdown.Item>$20 - $30</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>

                <Dropdown>
                  <Dropdown.Toggle variant="white" className="border">Select Status</Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item>Active</Dropdown.Item>
                    <Dropdown.Item>Inactive</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>

                <Dropdown>
                  <Dropdown.Toggle variant="white" className="border">Sort By : Last 7 Days</Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item>Recently Added</Dropdown.Item>
                    <Dropdown.Item>Last 7 Days</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </Col>
          </Row>

          {/* Search & Entries */}
          <Row className="mt-3 align-items-center">
            <Col md={6} className="d-flex align-items-center gap-3">
              <div>Row Per Page</div>
              <Form.Select style={{ width: '90px' }}>
                <option>10</option>
                <option>20</option>
                <option>50</option>
              </Form.Select>
              <div>Entries</div>
            </Col>
            <Col md={6} className="text-md-end mt-3 mt-md-0">
              <div className="position-relative" style={{ maxWidth: '300px', marginLeft: 'auto' }}>
                <TbSearch className="position-absolute top-50 start-0 translate-middle-y ms-3 text-muted" />
                <Form.Control
                  type="text"
                  placeholder="Search"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="ps-5"
                />
              </div>
            </Col>
          </Row>
        </Card.Header>

        {/* Table */}
        <Card.Body className="p-0">
          <div className="table-responsive">
            <Table hover className="mb-0 align-middle">
              <thead className="bg-light">
                <tr>
                  <th style={{ width: '50px' }}>
                    <Form.Check type="checkbox" />
                  </th>
                  <th>Pipeline Name</th>
                  <th>Total Deal Value</th>
                  <th>No of Deals</th>
                  <th>Stages</th>
                  <th>Created Date</th>
                  <th>Status</th>
                  <th style={{ width: '100px' }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {filteredData.map((item) => (
                  <tr key={item.id}>
                    <td>
                      <Form.Check type="checkbox" />
                    </td>
                    <td><h6 className="mb-0 fw-medium">{item.name}</h6></td>
                    <td className="fw-medium">{item.value}</td>
                    <td>{item.deals}</td>
                    <td>
                      <div className="d-flex align-items-center">
                        <div className="progress me-3" style={{ height: '6px', width: '90px', backgroundColor: '#f1f5f9' }}>
                          <div
                            className="progress-bar"
                            style={{
                              width: '100%',
                              backgroundColor: getStageColor(item.color)
                            }}
                          />
                        </div>
                        <span className="fw-normal">{item.stage}</span>
                      </div>
                    </td>
                    <td>{item.date}</td>
                    <td>
                      <Badge
                        bg={item.status === "Active" ? "success" : "danger"}
                        className="d-inline-flex align-items-center px-3 py-2"
                      >
                        <span className="me-1">●</span> {item.status}
                      </Badge>
                    </td>
                    <td>
                      <div className="d-flex gap-3">
                        <Button
                          variant="link"
                          className="p-0 text-muted"
                          onClick={() => handleEdit(item)}
                        >
                          <TbEdit size={20} />
                        </Button>
                        <Button
                          variant="link"
                          className="p-0 text-muted"
                          onClick={() => handleDelete(item)}
                        >
                          <TbTrash size={20} />
                        </Button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </Card.Body>
      </Card>

      {/* Modals */}
      {/* <AddPipelineModal show={showAddModal} onHide={() => setShowAddModal(false)} /> */}
      <EditPipelineModal
        show={showEditModal}
        onHide={() => setShowEditModal(false)}
        pipeline={selectedPipeline}
      />
      <DeleteConfirmModal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        onConfirm={confirmDelete}
        pipelineName={selectedPipeline?.name}
      />
  
    </div>
    
  );
};

export default PipelinePage;